import React from 'react';
import { Typography, NotificationBadge, Button } from '@up-riac/bespoke-ui';

export const MegaMenuLink = ({ to, onPress, label, description, notificationCount, id }: {to?: string, onPress?: () => void, id?: string, notificationCount?: number, label: React.ReactNode, description?: React.ReactNode}) => {
  const baseID = id || `mega-menu-link-${typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '-') : 'custom-label'}`;
  const MainContent = (
    <Typography size='sm' weight='bold' className='inline-flex gap-4 text-text-contrast' id={`${baseID}-main-content`}>
      <span className='group-hover/megamenu-link:underline underline-offset-5'>{label}</span>
      {notificationCount !== undefined && notificationCount > 0
        && <NotificationBadge count={notificationCount} id={`${baseID}-notification-badge`} className='decoration-transparent'/>
      }
    </Typography>
  );
  return (
    <div className='flex flex-col gap-0.5 w-[999px] max-w-full' id={baseID}>
      {(to || onPress)
        && <Button to={to} onPress={onPress} unstyled className='group/megamenu-link hover:no-underline inline w-max max-w-full' id={`${baseID}-link`}>
          {MainContent}
        </Button>
      || MainContent}
      {description && <Typography className='justify-between text-neutral-600 w-[999px] max-w-full' size='sm' id={`${baseID}-description`}>
        {description}
      </Typography> || ''}
    </div>
  );
};
